var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1258,
    height: 708,
    viewBox: "0 0 1258 708",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lost",
    clipPath: "url(#clip0_2470_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clothes1",
    d: "M522.16 272.36C531.89 223.36 525.46 185.84 519.89 164.58C513.69 140.88 508.28 121.38 489.89 108.38C467.89 92.7798 430.57 88.9698 412.42 106.38C403.533 105.218 394.498 106.062 385.98 108.85C361.79 116.91 350.98 138.62 345.98 148.85C339.56 162.05 332.62 176.32 338.59 184.43C346.99 195.84 378.5 191.68 396.37 174.73C396.1 179.81 395.85 185.27 395.62 191.21C394.09 231.21 394.62 264.11 395.38 286.72L428.38 283.51C436.69 312.904 443.173 342.785 447.79 372.98C451.43 396.89 452.13 409.27 454.27 425.9C458.21 456.55 466.88 500.55 488.22 554.69C489.709 560.827 493.449 566.181 498.7 569.69C501.963 571.761 505.679 573.013 509.53 573.34C517.964 571.237 526.587 569.981 535.27 569.59C551.03 568.88 556.58 571.52 563.35 568.51C569.87 565.61 577.35 557.51 580.35 534.25L522.16 272.36Z",
    fill: "#00479B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cactus2",
    d: "M273.95 421.47C273.95 395.39 265.05 374.25 254.07 374.25C243.09 374.25 234.2 395.39 234.2 421.47C234.157 429.403 235.047 437.314 236.85 445.04C230.63 444.184 224.359 443.759 218.08 443.77H217.08C218.8 404.45 218.08 378.77 204.54 367.35C196.65 360.69 184.9 359.35 176.43 365.17C166.18 372.26 158.43 391.61 163.03 487.17C157.738 486.038 152.341 485.475 146.93 485.49C142.875 485.487 138.827 485.798 134.82 486.42C136.692 475.02 137.609 463.483 137.56 451.93C137.56 413.28 128.12 381.93 116.47 381.93C104.82 381.93 95.39 413.25 95.39 451.93C95.39 476.93 99.39 498.83 105.28 511.2C106.124 513.828 107.617 516.201 109.62 518.1C110.572 519.23 111.712 520.187 112.99 520.93C120.67 526.42 132.99 529.93 146.93 529.93C153.177 529.953 159.402 529.194 165.46 527.67C167.71 559.67 171.24 598.67 177 643.14L215.62 644.06C212.42 585.06 213.06 537.13 214.25 504.06C214.6 494.28 215.04 484.99 215.47 476.18H218.05C244.84 476.18 266.55 468.88 266.55 459.89C266.545 459.38 266.474 458.872 266.34 458.38C270.98 449.92 273.95 436.52 273.95 421.47Z",
    fill: "#95C3FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Floor",
    d: "M613.16 707.68C951.799 707.68 1226.32 680.405 1226.32 646.76C1226.32 613.115 951.799 585.84 613.16 585.84C274.521 585.84 0 613.115 0 646.76C0 680.405 274.521 707.68 613.16 707.68Z",
    fill: "#C9E1FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shoes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M589.4 657.42C590.827 657.346 592.21 656.902 593.414 656.132C594.617 655.361 595.599 654.29 596.263 653.025C596.927 651.76 597.25 650.343 597.201 648.915C597.151 647.487 596.73 646.096 595.98 644.88L595.89 644.75C593.429 640.783 590.268 637.297 586.56 634.46C585.888 633.961 585.142 633.569 584.35 633.3C579.53 631.62 574.637 629.997 569.67 628.43C569.35 618.388 568.111 608.396 565.97 598.58C565.1 594.58 564.12 590.89 563.09 587.4C562.567 585.613 561.456 584.055 559.937 582.978C558.418 581.902 556.579 581.37 554.72 581.47L516.72 583.57C514.603 583.688 512.613 584.618 511.164 586.166C509.715 587.713 508.919 589.76 508.94 591.88L509.36 638.63H509.92L510.38 653.37C510.412 654.47 510.663 655.553 511.12 656.555C511.577 657.556 512.229 658.456 513.039 659.202C513.849 659.947 514.799 660.523 515.835 660.895C516.871 661.268 517.971 661.429 519.07 661.37L589.4 657.42Z",
    fill: "#00479B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M460.79 660.53C462.129 660.535 463.446 660.191 464.613 659.533C465.779 658.875 466.754 657.925 467.442 656.776C468.13 655.627 468.507 654.319 468.536 652.98C468.566 651.641 468.247 650.318 467.61 649.14L467.54 649.01C465.465 645.181 462.71 641.762 459.41 638.92C458.814 638.408 458.138 637.996 457.41 637.7C453.03 635.893 448.577 634.127 444.05 632.4C444.27 622.992 443.634 613.583 442.15 604.29C441.543 600.523 440.84 596.973 440.04 593.64C439.639 591.948 438.677 590.442 437.312 589.366C435.947 588.289 434.258 587.706 432.52 587.71H397.28C395.289 587.708 393.374 588.474 391.934 589.849C390.494 591.224 389.64 593.101 389.55 595.09C389.237 601.757 388.93 608.403 388.63 615.03C388.27 622.957 387.907 630.887 387.54 638.82H388.06L387.73 652.62C387.705 653.652 387.886 654.679 388.264 655.64C388.641 656.601 389.207 657.477 389.929 658.216C390.65 658.955 391.512 659.542 392.464 659.943C393.415 660.344 394.437 660.55 395.47 660.55L460.79 660.53Z",
    fill: "#00479B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M487.17 321.55C489 311.21 508.98 302.31 523.29 309.46C536.29 315.97 541.61 333.63 535.37 345.58C530.6 354.72 518.8 361.05 511.46 358.05C506.85 356.17 507.4 352.05 500.38 340.89C491.95 327.55 486.33 326.27 487.17 321.55Z",
    fill: "#FDCD99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M529.469 388.724L535.555 388.925C537.841 389.001 539.754 387.209 539.83 384.924L541.037 348.334C541.113 346.049 539.321 344.135 537.036 344.06L530.949 343.859C528.664 343.783 526.75 345.575 526.675 347.86L525.468 384.45C525.392 386.735 527.184 388.649 529.469 388.724Z",
    fill: "#FDCD99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M538.727 375.016L544.857 373.653C547.17 373.138 548.628 370.846 548.113 368.533L540.23 333.09C539.715 330.777 537.423 329.319 535.111 329.834L528.98 331.197C526.668 331.711 525.21 334.003 525.724 336.316L533.608 371.76C534.122 374.073 536.414 375.531 538.727 375.016Z",
    fill: "#FDCD99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M518.869 380.209L524.909 380.986C527.177 381.278 529.251 379.676 529.543 377.408L531.929 358.861C532.221 356.593 530.619 354.518 528.351 354.226L522.311 353.449C520.043 353.158 517.968 354.76 517.676 357.027L515.291 375.575C514.999 377.842 516.601 379.917 518.869 380.209Z",
    fill: "#FDCD99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M507.287 366.777L513.327 367.554C515.595 367.845 517.67 366.244 517.961 363.976L519.251 353.948C519.543 351.68 517.941 349.606 515.673 349.314L509.633 348.537C507.365 348.245 505.291 349.847 504.999 352.115L503.709 362.142C503.417 364.41 505.019 366.485 507.287 366.777Z",
    fill: "#FDCD99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M488.88 58.2401C488.93 69.8001 471.08 84.3701 452.46 83.9401C436.74 83.5701 420.96 72.54 419.01 60.78C418.13 55.5 420.81 54.67 421.32 41.78C421.74 31.21 420.06 28.9201 422.19 23.5901C424.59 17.5901 429.19 14.2501 434.32 10.5901C440.22 6.35009 445.89 2.28005 454.24 1.93005C462.79 1.58005 472.02 5.22008 477.62 12.3301C480.177 15.6454 481.954 19.4939 482.82 23.5901C484.41 30.5901 482.32 33.15 482.82 40.04C483.57 50.42 488.85 51.9701 488.88 58.2401Z",
    fill: "#FDCD99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M454.441 43.7167C455.307 36.7785 453.267 30.8121 449.885 30.3903C446.504 29.9686 443.061 35.2511 442.196 42.1893C441.33 49.1275 443.37 55.0939 446.752 55.5156C450.133 55.9374 453.576 50.6549 454.441 43.7167Z",
    fill: "#FAB06D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clothes2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M422.12 583.39L397.05 581.55C393.961 581.325 390.947 580.493 388.18 579.102C385.412 577.712 382.946 575.79 380.922 573.446C378.897 571.102 377.355 568.382 376.381 565.442C375.408 562.502 375.024 559.399 375.25 556.31C368.909 462.348 375.595 367.96 395.12 275.83L444.98 271.29C448.069 271.516 451.083 272.347 453.85 273.738C456.618 275.128 459.084 277.051 461.108 279.394C463.133 281.738 464.675 284.458 465.649 287.398C466.622 290.338 467.006 293.441 466.78 296.53C469.821 346.927 469.039 397.481 464.44 447.76C460.942 486 455.242 524.006 447.37 561.59C447.26 563.18 446.49 571.48 422.12 583.39Z",
    fill: "#2E83EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M498.55 299.54C491.962 302.705 485.794 306.679 480.19 311.37C473.476 308.445 467.206 304.594 461.56 299.93C440.16 282.18 439.56 262.36 425.25 205.93C417.778 176.414 413.543 146.173 412.62 115.74C412.472 111.814 413.402 107.923 415.309 104.489C417.217 101.055 420.029 98.2086 423.44 96.26C426.389 94.5372 429.735 93.6103 433.15 93.5701C443.49 93.5701 451 102.77 455.81 109.32C484.12 147.82 496.23 195.09 496.23 195.09C498.949 211.364 503.02 227.383 508.4 242.98C516.86 267.46 525.8 282.64 519.07 290.85C515.57 295.18 511.18 293.49 498.55 299.54Z",
    fill: "#2E83EA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Cactus1",
    d: "M1233 406.06C1236.37 402.798 1238.89 398.765 1240.35 394.31C1250.75 372.66 1257.68 334.26 1257.68 290.48C1257.68 222.85 1241.16 168.02 1220.78 168.02C1200.4 168.02 1183.88 222.85 1183.88 290.48C1183.79 310.702 1185.39 330.895 1188.67 350.85C1181.66 349.756 1174.57 349.211 1167.48 349.22C1158.01 349.194 1148.56 350.179 1139.3 352.16C1147.43 184.81 1133.78 150.98 1115.85 138.56C1101.02 128.29 1080.46 130.72 1066.65 142.37C1042.96 162.37 1041.65 207.29 1044.7 276.12H1043.01C1032.02 276.096 1021.04 276.835 1010.15 278.33C1013.31 264.814 1014.88 250.972 1014.8 237.09C1014.8 191.45 999.23 154.45 980.01 154.45C960.79 154.45 945.22 191.45 945.22 237.09C945.22 263.43 950.42 286.87 958.5 302C958.258 302.856 958.134 303.74 958.13 304.63C958.13 320.38 996.13 333.14 1043.01 333.14C1044.52 333.14 1046.01 333.14 1047.52 333.14C1048.28 348.55 1049.04 364.81 1049.65 381.93C1051.74 439.74 1052.86 523.59 1047.26 626.93L1114.85 625.31C1124.92 547.5 1131.11 479.17 1135.05 423.22C1145.65 425.912 1156.54 427.256 1167.48 427.22C1191.77 427.22 1213.32 421.03 1226.76 411.47C1229.16 410.066 1231.27 408.232 1233 406.06Z",
    fill: "#75B2FC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tumbleweeds"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M753.72 623.48L739.59 613.33C703.59 587.52 696.68 539.11 724.05 505.2L734.79 491.87C762.15 457.96 813.49 451.4 849.44 477.21L863.57 487.36C899.57 513.17 906.48 561.59 879.11 595.49L868.35 608.82C841 642.73 789.67 649.29 753.72 623.48Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M895.12 577.83L768.76 641.03L699.98 517.67L826.34 454.47L895.12 577.83Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M806.98 612.97L785.41 611.18C751.71 608.38 726.07 579.84 728.13 547.44L729.45 526.69C731.52 494.29 760.51 470.29 794.2 473.09L815.79 474.88C849.49 477.68 875.13 506.22 873.07 538.62L871.75 559.37C869.67 591.77 840.68 615.77 806.98 612.97Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M773.61 622.09C735.34 604.33 718.49 560.39 735.98 523.96C753.46 487.53 798.66 472.39 836.93 490.15C875.19 507.92 892.04 551.85 874.56 588.29C857.07 624.72 811.87 639.85 773.61 622.09Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M836.29 598.49C813.65 613.96 774.16 600.92 748.1 569.38C722.04 537.83 719.26 499.73 741.9 484.26C764.55 468.8 804.03 481.83 830.09 513.38C856.16 544.92 858.93 583.03 836.29 598.49Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M699.79 594.67C694.79 582.32 734.79 552.97 789 529.12C843.25 505.26 891.26 495.93 896.23 508.28C901.23 520.63 861.23 549.98 807.02 573.84C752.79 597.69 704.79 607.02 699.79 594.67Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M861.03 447.85L895.03 545.08C879.29 553.5 863.507 561.833 847.68 570.08C831.067 578.747 814.4 587.35 797.68 595.89C822.28 577.89 827.35 552.57 819.34 543.5C811.33 534.43 784.34 534.61 761.16 553.72C768.978 536.106 773.116 517.08 773.32 497.81C773.38 480.88 772.32 472.2 775.53 454.47C775.91 452.154 776.952 449.997 778.53 448.26C784.79 441.57 800.05 441.83 809.78 448.53C814.644 451.979 818.203 456.968 819.88 462.69C811.88 450.9 792.42 423.44 784.38 426.69C776.61 429.77 777.2 462.45 794.19 473.1C809.64 482.76 840.02 475.1 861.03 447.85Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M872.9 589.54C844.57 600.54 806.62 580.2 788.15 544.07C769.68 507.94 777.67 469.72 806 458.7C834.34 447.7 872.28 468.04 890.75 504.17C909.22 540.31 901.23 578.53 872.9 589.54Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M789.64 637.26C776.39 633 777.17 588.69 791.4 538.26C805.62 487.86 827.89 450.45 841.15 454.71C854.4 458.97 853.62 503.28 839.39 553.71C825.17 604.11 802.9 641.51 789.64 637.26Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M897.96 578.85C892.55 591.03 845.73 587.25 793.39 570.4C741.06 553.56 703.02 530.03 708.39 517.85C713.81 505.67 760.62 509.46 812.96 526.3C865.34 543.18 903.38 566.67 897.96 578.85Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M853.28 514.35C860.207 534.217 867.143 554.083 874.09 573.95C864.443 579.11 854.777 584.227 845.09 589.3C834.91 594.633 824.703 599.903 814.47 605.11C829.54 594.05 832.66 578.56 827.74 573C822.82 567.44 806.31 567.55 792.08 579.27C796.878 568.475 799.414 556.812 799.53 545C799.59 531.07 796.03 522.39 800.89 518.43C804.11 515.81 811.18 515.11 828.08 523.43L853.28 514.35Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M804.39 529.08L825.21 588.68C815.557 593.84 805.89 598.953 796.21 604.02C786.043 609.353 775.837 614.627 765.59 619.84C780.67 608.78 783.78 593.29 778.87 587.73C773.96 582.17 757.43 582.28 743.21 594C747.999 583.202 750.534 571.541 750.66 559.73C750.72 545.79 747.16 537.12 752.02 533.16C755.23 530.54 762.31 529.84 779.21 538.16L804.39 529.08Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M847.1 479.38C854.04 499.24 860.977 519.103 867.91 538.97C858.257 544.13 848.59 549.247 838.91 554.32C828.73 559.653 818.523 564.923 808.29 570.13C823.37 559.07 826.48 543.58 821.56 538.02C816.64 532.46 800.13 532.57 785.91 544.29C790.699 533.492 793.234 521.831 793.36 510.02C793.41 496.09 789.86 487.41 794.71 483.45C797.93 480.83 805 480.14 821.91 488.45L847.1 479.38Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M776.615 586.997C795.209 580.1 806.125 563.297 800.995 549.467C795.865 535.636 776.632 530.015 758.038 536.912C739.443 543.808 728.527 560.611 733.657 574.442C738.787 588.273 758.02 593.894 776.615 586.997Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M819.124 576.448C834.455 568.029 837.347 543.835 825.582 522.408C813.817 500.982 791.851 490.436 776.519 498.855C761.188 507.273 758.296 531.467 770.061 552.894C781.826 574.32 803.792 584.866 819.124 576.448Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M786.445 570.553C804.703 565.279 815.824 548.264 811.285 532.548C806.745 516.831 788.265 508.366 770.007 513.639C751.749 518.912 740.628 535.928 745.167 551.644C749.706 567.36 768.187 575.826 786.445 570.553Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M815.538 570.119C827.103 565.618 833.978 555.547 830.895 547.626C827.811 539.706 815.937 536.934 804.372 541.436C792.808 545.938 785.932 556.008 789.016 563.929C792.099 571.85 803.974 574.621 815.538 570.119Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M715.24 623.73C717.307 621.21 719.443 618.69 721.65 616.17C744.598 590.215 771.52 568.067 801.41 550.55",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M780.29 612.28C780.12 630.36 769 644.4 755.57 646.72C746.65 648.26 738.94 644.24 735.69 642.26",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M688.56 477.08C696.267 472.787 705.124 471.015 713.89 472.01C723.058 473.074 731.604 477.184 738.16 483.68",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M102.7 620.51L95.02 615C75.48 601 71.7 574.67 86.58 556.24L92.42 549C107.29 530.57 135.19 527 154.72 541L162.4 546.52C181.94 560.52 185.72 586.85 170.85 605.28L165 612.52C150.13 630.97 122.24 634.54 102.7 620.51Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M179.54 595.71L110.87 630.05L73.5 563.01L142.16 528.67L179.54 595.71Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M131.64 614.8L119.92 613.8C101.61 612.28 87.68 596.8 88.8 579.16L89.51 567.89C90.64 550.28 106.39 537.24 124.7 538.76L136.42 539.76C154.73 541.29 168.66 556.76 167.54 574.4L166.83 585.67C165.7 603.28 149.95 616.33 131.64 614.8Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M113.51 619.76C92.71 610.11 83.56 586.23 93.06 566.43C102.56 546.63 127.12 538.43 147.91 548.06C168.71 557.71 177.86 581.59 168.36 601.39C158.86 621.18 134.3 629.41 113.51 619.76Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M147.57 606.94C135.26 615.34 113.81 608.26 99.65 591.11C85.48 573.97 83.98 553.27 96.28 544.86C108.58 536.46 130.04 543.54 144.2 560.68C158.36 577.82 159.87 598.53 147.57 606.94Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M73.3801 604.86C70.6801 598.15 92.3801 582.2 121.86 569.24C151.33 556.24 177.42 551.24 180.12 557.91C182.83 564.62 161.12 580.57 131.65 593.54C102.17 606.5 76.0801 611.57 73.3801 604.86Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M161.01 525.08L179.46 577.91C170.913 582.49 162.337 587.027 153.73 591.52C144.71 596.24 135.663 600.907 126.59 605.52C139.95 595.71 142.71 581.98 138.36 577.05C134.01 572.12 119.36 572.22 106.74 582.61C110.993 573.04 113.243 562.702 113.35 552.23C113.35 543.03 112.79 538.31 114.55 528.67C114.767 527.414 115.336 526.246 116.19 525.3C119.59 521.67 127.88 521.81 133.19 525.45C135.832 527.323 137.766 530.032 138.68 533.14C134.33 526.74 123.75 511.82 119.39 513.55C115.03 515.28 115.49 532.99 124.72 538.77C133.09 544.05 149.59 539.89 161.01 525.08Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M167.46 602.07C152.07 608.07 131.46 597 121.46 577.36C111.46 557.73 115.77 536.96 131.16 530.97C146.56 524.97 167.16 536.05 177.21 555.68C187.2 575.32 182.86 596.09 167.46 602.07Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M122.22 628C115.02 625.69 115.44 601.61 123.17 574.22C130.9 546.83 143 526.5 150.17 528.82C157.37 531.13 156.94 555.21 149.17 582.6C141.53 609.99 129.42 630.31 122.22 628Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M181.08 596.26C178.14 602.88 152.7 600.83 124.26 591.67C95.82 582.52 75.15 569.73 78.09 563.12C81.03 556.5 106.47 558.55 134.91 567.71C163.35 576.86 184.02 589.64 181.08 596.26Z",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M117.14 614.43C117.05 624.25 111 631.88 103.7 633.14C98.86 633.98 94.7 631.79 92.9 630.72",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M67.29 540.96C71.4778 538.62 76.2924 537.648 81.06 538.18C86.0412 538.752 90.6844 540.985 94.24 544.52",
    stroke: "#198ECE",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M486.99 26.8C476.79 23.33 465.64 21.42 459.61 26.94C453.58 32.46 456.9 39.97 454.5 40C454.5 31.5 451.829 30.5 447 30.5C443.829 34.8401 442.5 46.5 432 51.6C427.409 56.182 425.34 59.3654 419.01 60.7799C418.23 59.3299 407.36 38.46 418.01 20.05C427.44 3.71996 446.69 1.61999 458.43 0.339994C469.18 -0.840006 473.6 1.33999 475.19 2.33999C486.34 8.73999 486.94 24.61 486.99 26.8Z",
    fill: "#134D65"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2470_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1257.68,
    height: 707.68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLost);
export default __webpack_public_path__ + "static/media/Lost.e1a8bba10102dd84e2ca6a2eac004bbf.svg";
export { ForwardRef as ReactComponent };